export default __webpack_public_path__ + "static/media/living-cz-logo-light-bg.3c0f7c26.svg";